module.exports = __webpack_public_path__ + "media/registration/webinars@2x-092c0fd6.png";